export default __webpack_public_path__ + "static/media/success.49a3dc3f.svg";